import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter, Link, useLocation } from "react-router-dom"
import { isEmpty, set } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import cellEditFactory from "react-bootstrap-table2-editor"
import * as Yup from "yup"
import { useFormik } from "formik"

// import DeleteModal from "../../../components/Common/DeleteModal";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import * as moment from "moment"

import {
  Card,
  CardBody,
  Col,
  Container,
  Row
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import SweetAlert from "react-bootstrap-sweetalert";


import {
  getOrders as onGetOrders,
  addNewOrder as onAddNewOrder,
  updateOrder as onUpdateOrder,
  deleteOrder as onDeleteOrder,
  getAuthUsers as onGetAuthUser,
  convertToOrder,
} from "store/actions"

import OrdersOrdersModal from "./OrderOrdersModal"
import Columns from "./Columns"
import { expandRow } from "./orderDetails"
import OffCanvasModel from "components/OrdersOffCanvas/offCanvas"
import FilterComponentForOrders from "components/Common/filterComponentForOrders"
import { removeEmptyValues } from "common/CommonFunction"

const OrdersOrders = props => {
  const dispatch = useDispatch()
  let location = useLocation()

  const [orderList, setOrderList] = useState([])
  const [order, setOrder] = useState(null)

  // validation
  const validation = useFormik({
    
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      orderId: (order && order.orderId) || "",
      billingName: (order && order.billingName) || "",
      orderdate: (order && order.orderdate) || "",
      total: (order && order.total) || "",
      paymentStatus: (order && order.paymentStatus) || "Paid",
      badgeclass: (order && order.badgeclass) || "success",
      paymentMethod: (order && order.paymentMethod) || "Mastercard",
    },
    
    validationSchema: Yup.object({
      orderId: Yup.string().required("Please Enter Your Order Id"),
      billingName: Yup.string().required("Please Enter Your Billing Name"),
      orderdate: Yup.string().required("Please Enter Your Order Date"),
      total: Yup.string().required("Total Amount"),
      paymentStatus: Yup.string().required("Please Enter Your Payment Status"),
      badgeclass: Yup.string().required("Please Enter Your Badge Class"),
      paymentMethod: Yup.string().required("Please Enter Your Payment Method"),
    }),
    
    onSubmit: values => {
      if (isEdit) {
        const updateOrder = {
          id: order ? order.id : 0,
          orderId: values.orderId,
          billingName: values.billingName,
          orderdate: values.orderdate,
          total: values.total,
          paymentStatus: values.paymentStatus,
          paymentMethod: values.paymentMethod,
          badgeclass: values.badgeclass,
        }
        // update order
        dispatch(onUpdateOrder(updateOrder))
        validation.resetForm()
      } else {
        const newOrder = {
          id: Math.floor(Math.random() * (30 - 20)) + 20,
          orderId: values["orderId"],
          billingName: values["billingName"],
          orderdate: values["orderdate"],
          total: values["total"],
          paymentStatus: values["paymentStatus"],
          paymentMethod: values["paymentMethod"],
          badgeclass: values["badgeclass"],
        }
        // save new order
        dispatch(onAddNewOrder(newOrder))
        validation.resetForm()
      }
    
      toggle()
    
    },
  })

  const { orders, designerUsers, salesUsers } = useSelector(state => ({
    orders: state.Orders.orders,
    designerUsers: state.Login.designers,
    salesUsers: state.Login.sales,
  }))

  const selectRow = {
    mode: "checkbox",
  }
  const paginate = { size: 50, page: 1 }

  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isRight, setIsRight] = useState(false)
  const [order1, setOrder1] = useState(null);

  const [alert, setAlert] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [designers, setDesigners] = useState([
    { value: "", label: "All Designers" },
  ])
  const [sales, setSales] = useState([{ value: "", label: "All Sales" }])

  const [path, setPath] = useState(location.pathname.split("/")[1])
  const [filter, setFilter] = useState({})
  const [pageOptions, setPageOptions] = useState({
    sizePerPage: paginate.size,
    page: paginate.page,
    totalSize: paginate.size,
    custom: true,
  })

  useEffect(() => {
    setPath(location.pathname.split("/")[1])
    console.log("4444444444444")
    handlePage(filterFunction(1))
  }, [location])

  useEffect(() => {

// console.log("designerUsers", designerUsers)
    if (designerUsers.hasOwnProperty("docs") && designers.length == 1) {


      setDesigners(designerUsers.docs)

    }
    // else{
    //   dispatch(onGetAuthUser({ role: "designer" }))
    // }
  }, [designerUsers])

  useEffect(() => {
    if (salesUsers.hasOwnProperty("docs") && sales.length == 1) {
      setSales(salesUsers.docs)
    }
  }, [salesUsers])

  const toggleViewModal = (order) => {
    setOrder1(order)
    setModal1(!modal1)
  }

  const toLowerCase1 = str => {
    return str === "" || str === undefined ? "" : str.toLowerCase()
  }
  const handlePage = json => {
    
    let locPath = location.pathname.split("/")[2];
    console.log("json=====", json, locPath)
    switch (locPath) {
      case "all-quotes":
        dispatch(onGetOrders(json))
        break
      case "todays-quotes":
        json.params.orderStatus = "New"
        dispatch(onGetOrders(json))
        break
      case "ready-quotes":
        json.params.orderStatus = "Ready"
        dispatch(onGetOrders(json))
        break
      case "convert-to-order":
        json.params.orderStatus = "Done"
        dispatch(onGetOrders(json))
        break
      case "vector-with-price-zero":
        json.params.price = 0
        dispatch(onGetOrders(json))
        break
      case "all-vectors":
        // json.params.orderStatus ="New"
        dispatch(onGetOrders(json))
        break
      case "todays-vectors":
        json.params.orderStatus = "New"
        dispatch(onGetOrders(json))
        break
      case "ready-vectors":
        json.params.orderStatus = "Ready"
        dispatch(onGetOrders(json))
        break
      case "vector-with-price":
        // json.params.price = 0
        dispatch(onGetOrders(json))
        break
      case "orders-with-price-zero":
        json.params.price = 0
        dispatch(onGetOrders(json))
        break
      case "all-orders":
        dispatch(onGetOrders(json))
        break
      case "todays-orders":
        json.params.orderStatus = "New"
        dispatch(onGetOrders(json))
        break
      case "ready-orders":
        json.params.orderStatus = "Ready"
        dispatch(onGetOrders(json))
        break
      case "orders-with-price":
        // json.params.price = 0
        dispatch(onGetOrders(json))
        break
      default:
        break
    }
  }

  useEffect(() => {
    if (!orders.hasOwnProperty("docs")) {
      const json = filterFunction(1)
      setFilter(json)
      console.log("1111111111111111")
      handlePage(json)
    }
  }, [orders])

  useEffect(() => {
    if (!isEmpty(orders) && !!isEdit) {
      setOrderList(orders)
      setIsEdit(false)
    }
    setOrderList(orders)
    setPageOptions({
      sizePerPage: orders.limit,
      page: orders.offset,
      totalSize: orders.totalDocs,
      custom: true,
    })
  }, [orders])

  const toggle = () => {
    if (modal) {
      setModal(false)
      setOrder(null)
    } else {
      setModal(true)
    }
  }

  const handleOrderClick = arg => {
    const order = arg

    setOrder({
      id: order.id,
      orderId: order.orderId,
      billingName: order.billingName,
      orderdate: order.orderdate,
      total: order.total,
      paymentStatus: order.paymentStatus,
      paymentMethod: order.paymentMethod,
      badgeclass: order.badgeclass,
    })

    setIsEdit(true)

    toggle()
  }

  var node = useRef()

  const onClickDelete = order => {
    dispatch(onDeleteOrder(order._id))
  }

  const handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y")
    return date1
  }

  const toggleRightCanvas = () => {
    setIsRight(!isRight)
  }

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]

  const handleChange = (oldValue, newValue, row, column, done) => {
    if (column.dataField === "assTo") {
      dispatch(onUpdateOrder(row))
    } else {
      dispatch(onUpdateOrder(row))
    }
  }

  const handleFilterClick = searchParam => {
    let json = removeEmptyValues(JSON.parse(JSON.stringify(searchParam)))
    setFilter(json)
    json = {
      params: { requestFor: path, delete: "false", ...json },
      paginate: { size: 50, page: 1 },
    }
    console.log("222222222222222222")
    handlePage(json)
    // dispatch(onGetOrders(json))
  }

  const handleTableChange = (type, { page, sizePerPage }) => {
    const json = filterFunction(page)
    const queryString = new URLSearchParams({
      ...json.params,
      ...json.paginate,
    }).toString()
    window.history.pushState({}, "", `${location.pathname}?${queryString}`)
    console.log("333333333333333")
    handlePage(json)
    // dispatch(onGetOrders(json))
  }

  function filterFunction(page) {
    const queryParams = new URLSearchParams(location.search)

    const params = { requestFor: path, delete: "false", ...filter }

    for (let [key, value] of queryParams.entries()) {
      params[key] = value
    }

    params.page = params.page > 1 ? params.page : page
    delete params.size

    let json = { params, paginate: { size: paginate.size, page: params.page } }
    return json
  }

  function slugToTitle(str) {
    return str
      .split('-') // split on hyphen
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // capitalize each
      .join(' '); // join with space
  }

  const handleConfirm = (orderCode) => {
    setAlert(<SweetAlert
      warning
      confirmBtnText="Yes, please!"
      cancelBtnText="Cancel"
      confirmBtnBsStyle="danger"
      title="Do you really want to convert this quote to order?"
      onConfirm={() => {
        dispatch(convertToOrder({ requestFor: "order",orderCode, convertToOrder: true,orderStatus:"New",price:0, convertToOrderDate: new Date() }))
        setAlert(null)
      }}
      onCancel={() => setAlert(null)}
      focusCancelBtn
    >
    </SweetAlert>)
  };

  const handleDelete = () => {
    setData((prev) => prev.filter((item) => item._id !== deleteId));
    setAlert(
      <SweetAlert
        success
        title="Deleted!"
        onConfirm={() => { }}
      >
        Record has been deleted successfully.
      </SweetAlert>
    );
  };

  return (
    <React.Fragment>
      <OffCanvasModel isRight={isRight} toggleRightCanvas={toggleRightCanvas} />
      {modal1 ? (<OrdersOrdersModal isOpen={modal1} toggle={toggleViewModal} processData={order1} />) : null}
      {alert}
  
      <div className="page-content">
        <MetaTags>
          <title>Orders</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={path.charAt(0).toUpperCase() + path.slice(1)} breadcrumbItem={slugToTitle(location.pathname.split("/")[2])} />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="_id"
                    columns={Columns(
                      toggle,
                      handleValidDate,
                      handleOrderClick,
                      onClickDelete,
                      toLowerCase1,
                      toggleViewModal,
                      designers,
                      sales,
                      handleConfirm
                    )}
                    data={orders.hasOwnProperty("docs") ? orders.docs : orders}
                  // cellEdit={ cellEditFactory({ mode: 'click' }) }
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="_id"
                        data={
                          orders.hasOwnProperty("docs") ? orders.docs : orders
                        }
                        columns={Columns(
                          toggle,
                          handleValidDate,
                          handleOrderClick,
                          onClickDelete,
                          toLowerCase1,
                          toggleViewModal,
                          designers,
                          sales,
                          handleConfirm
                        )}
                        bootstrap4
                      // search
                      // cellEdit={ cellEditFactory({ mode: 'click' }) }
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Col sm="12">
                              <FilterComponentForOrders
                                handleFilterClick={handleFilterClick}
                              />
                            </Col>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    remote={{
                                      filter: true,
                                      pagination: true,
                                      sort: false,
                                      cellEdit: false,
                                    }}
                                    keyField="_id"
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    // selectRow={selectRow}
                                    classes={
                                      "table align-middle table-nowrap table-check"
                                    }
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    onTableChange={handleTableChange}
                                    cellEdit={cellEditFactory({
                                      mode: "dbclick",
                                      blurToSave: true,
                                      afterSaveCell: handleChange,
                                    })}
                                    expandRow={expandRow}
                                    ref={node}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

OrdersOrders.propTypes = {
  orders: PropTypes.array,
  onGetOrders: PropTypes.func,
  onAddNewOrder: PropTypes.func,
  onDeleteOrder: PropTypes.func,
  onUpdateOrder: PropTypes.func,
}

export default withRouter(OrdersOrders)
